import { observer } from 'mobx-react-lite';
import { AppIconType } from '../../../lib/typegen/app-icon-type';
import GenericButton from '../../button-generic';
import MessageBox from '../../message-box';
import checkReturnedImage from '../../../assets/check-returned.png';
import style from '../style.module.scss';
import { useStore } from '../../../lib/hooks/useStore';

interface GetCheckViewProps {
	doneCallback: () => void;
}

const GetCheckView = observer(({ doneCallback }: GetCheckViewProps) => {
	const {
		configStore: { getString },
	} = useStore();

	return (
		<section className={style['returned-check']}>
			<img src={checkReturnedImage} alt='check returned' className={style['returned-check__image']} />
			<MessageBox className={style['returned-check__info']} type='info'>
				{getString('please-take-your-check')}
			</MessageBox>
			<p className={style['returned-check__question']}>{getString('did-you-take-your-check')}</p>
			<GenericButton
				icon={AppIconType.AcceptSolid}
				className={style['returned-check__action']}
				innerText={getString('yes')}
				onClick={doneCallback}
				hasGlow={true}
				isGrowHorizontally={false}
			/>
		</section>
	);
});

export default GetCheckView;
